import { observable } from "mobx";

class SearchDataSource {

	@observable listeners:Array<any> = [];
	@observable searchText:string = "";

	addListener = (listenerToAdd) => {
		var idx = this.listeners.indexOf(listenerToAdd);
		if(-1===idx) {
			this.listeners.push(listenerToAdd);
		}
	}

	removeListener = (listenerToRemove) => {
		const idx = this.listeners.indexOf(listenerToRemove);
		if(-1!=idx){
			this.listeners.splice(idx, 1);
		}
	}

	notifyListeners = () => {
		this.listeners.forEach(listener => {
			listener();
		});		
	}

	setSearchText = (searchText) => {
		this.searchText = searchText;
		this.notifyListeners();    
	}

	getSearchText = () => {
		return this.searchText;
	}

};

let searchDataSource = new SearchDataSource();


export {searchDataSource};
